module.exports = __webpack_public_path__ + "grouping-grouped.769149b3c9e233e72943.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grouping-grouped.svg
// module id = ./src/assets/img/grouping-grouped.svg
// module chunks = main